import pagesJson from '@/pages.json';
import { values, map, filter } from 'lodash-es';

// tabbar
export const tabbar = map(values(pagesJson.tabBar.list), (item) => `/${item.pagePath}`);

export interface Route {
	pack: 'main' | string;
	path: string;
	title: string;
	custom: boolean;
	textStyle: string;
	bgColor: string;
}

// 所有路由信息
export const routes = (() => {
	const allRoutes: Route[] = [];

	// 收集主包中的页面
	pagesJson.pages.forEach((page: any) => {
		allRoutes.push({
			pack: 'main',
			path: `/${page.path}`,
			title: page.style?.navigationBarTitleText || '',
			custom: page.style?.navigationStyle === 'custom',
			textStyle: page.style?.navigationBarTextStyle || 'black',
			bgColor: page.style?.navigationBarBackgroundColor || '#ffffff',
		});
	});

	// 收集子包中的页面
	if (pagesJson.subPackages) {
		pagesJson.subPackages.forEach((subPackage) => {
			subPackage.pages.forEach((page) => {
				allRoutes.push({
					pack: subPackage.root,
					path: `/${subPackage.root}/${page.path}`,
					title: page.style?.navigationBarTitleText || '',
					custom: page.style?.navigationStyle === 'custom',
					textStyle: page.style?.navigationBarTextStyle || 'black',
					bgColor: page.style?.navigationBarBackgroundColor || '#ffffff',
				});
			});
		});
	}

	return allRoutes;
})();

// 从routes中过滤所有设置了navigationStyle: "custom"的页面路径
export const customPaths = map(filter(routes, 'custom'), 'path');

// 非原生路由（需要通过webview打开的页面）
export const nonNative: string[] = [];

// 不需要登录
export const noLogin = [
	'/pages/home',
	'/pages/webview',
	'/pages/mycenter/index',
	'/pages/mycenter/agreement',
	'/pages/mycenter/login/index',
	'/pages/mycenter/login/pwd',
	'/pages/mycenter/login/register',
	'/pages/mycenter/login/bind-mobile',
	'/pages/setting/pwd',
	'/pages/setting/download',
	'/pages/setting/agreement',
	'/pages/shop/school/index',
	'/pages/shop/school/detail',
	'/pages/shop/school/cate',
	'/pages/goods/search/index',
	'/pages/goods/search/list',
	'/pages/goods/anti-fake',
	'/pages/goods/bidding',
	'/pages/goods/exchange',
	'/pages/goods/flash',
	'/pages/goods/list',
	'/pages/goods/detail',
	'/pages/goods/cate',
	'/pages/goods/area',
	'/pages/goods/mall',
	'/pages/goods/gift',
	'/pages/goods/self',
	'/pages/goods/area-list',
	'/pages/notice/index',
	'/pages/notice/detail',
	'/pages/collection/payment/index',
	'/pages/collection/payment/success',
	'/pages/intracity/index',
	'/pages/intracity/goods/list',
	'/pages/intracity/goods/detail',
	'/pages/intracity/shop/list',
	'/pages/intracity/shop/detail',
	'/pages/intracity/shop/info',
];

export const needMerchLogin = [
	'/pages/shop/manage/index',
	'/pages/shop/manage/edit',
	'/pages/shop/manage/menu',
	'/pages/shop/manage/feedback',
	'/pages/shop/manage/clock',
	'/pages/shop/wallet/index',
	'/pages/shop/wallet/record',
	'/pages/shop/proxy/bonus',
	'/pages/shop/proxy/merchant',
	'/pages/shop/proxy/index',
	'/pages/shop/order/list',
	'/pages/shop/order/detail',
	'/pages/shop/order/address',
	'/pages/shop/order/send',
	// '/pages/shop/school/index',
	// '/pages/shop/school/detail',
	// '/pages/shop/school/cate',
	'/pages/shop/goods/manage',
	'/pages/shop/dispatch/edit',
	'/pages/shop/dispatch/list',
	'/pages/shop/address/edit',
	'/pages/shop/address/list',
	'/pages/shop/setting/index',
	'/pages/shop/redemption',
	'/pages/shop/comment/list',
	'/pages/shop/comment/detail',
	'/pages/shop/yop/apply',
	'/pages/shop/yop/detail',
	'/pages/shop/invoice/index',
	'/pages/shop/invoice/detail',
	'/pages/shop/invoice/edit',
	'/pages/goods/edit/entrance',
	'/pages/goods/edit/cate',
	'/pages/goods/edit/intracity',
	'/pages/goods/edit/tire',
	'/pages/goods/edit/normal',
];
